import { render, staticRenderFns } from "./QuotePeopleRange.vue?vue&type=template&id=f5ce9e7e"
import script from "./QuotePeopleRange.vue?vue&type=script&lang=js"
export * from "./QuotePeopleRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports